export const userAccountQueryKey = ['luxola-account'] as const
